<!-- class tree-field-tooltip-parent is used for internal ispui-tootip components, to pass them attachNode parameter -->
<ngispui-tree
  [dataSource]="to.dataSource"
  [treeControl]="treeControl"
  [trackBy]="trackByNode"
  class="tree tree-field-tooltip-parent"
  [style.height]="height"
>
  <ngispui-nested-tree-node
    #treeElement
    *ngispuiTreeNodeDef="let node"
    class="tree__branch"
  >
    <div
      class="tree__label"
      [ngClass]="{ tree__label_is_selected: node.$key === formControl.value }"
    >
      <ispui-preloader-round
        *ngIf="node.isLoading; else folder"
        [loading]="node.isLoading"
        view="local"
        class="tree__preloader"
        [spinnerSize]="20"
      >
      </ispui-preloader-round>
      <ng-template #folder>
        <isp-svg-icon
          (click)="toggle(node)"
          [customStyle]="{ width: '20px', height: '20px' }"
          [name]="getTreeIcon(node) | iconSimular"
          [ngClass]="{ tree__icon_is_extendable: isExpandable(node) }"
        ></isp-svg-icon>
      </ng-template>
      <span class="tree__text" (click)="select(node)" (dblclick)="toggle(node)">
        <ispui-tooltip ellipsis viewport-selector=".tree-field-tooltip-parent">
          {{ node.$ }}
        </ispui-tooltip>
      </span>
    </div>
    <ng-container
      ngispuiTreeNodeOutlet
      *ngIf="treeControl.isExpanded(node)"
    ></ng-container>
  </ngispui-nested-tree-node>
</ngispui-tree>
